import { render, staticRenderFns } from "./SponsorshipList.vue?vue&type=template&id=1d8862c0&"
import script from "./SponsorshipList.vue?vue&type=script&lang=js&"
export * from "./SponsorshipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports